import React from 'react';
import { Info } from 'lucide-react';
import { getLastDataUpdateInfo } from '../../utils/dataFreshness';

interface DataFreshnessBannerProps {
  hasPeriodSelector: boolean;
  className?: string;
}

const DataFreshnessBanner: React.FC<DataFreshnessBannerProps> = ({
  hasPeriodSelector,
  className = '',
}) => {
  const { formattedDate, hint } = getLastDataUpdateInfo(hasPeriodSelector);

  return (
    <div
      className={`inline-flex w-auto max-w-full items-center gap-1.5 rounded-md border border-border-primary bg-bg-card px-3 py-2 text-sm text-text-secondary shadow-sm ${className}`}
      dir="rtl"
      role="status"
      aria-live="polite"
      title={`آخرین بروزرسانی داده تا ${formattedDate}${hint ? ` (${hint})` : ''}`}
    >
      <Info size={14} className="text-accent-cyan shrink-0" strokeWidth={2.25} aria-hidden="true" />
      <span>
        آخرین بروزرسانی:{' '}
        <span className="font-medium text-text-primary">{formattedDate}</span>
        {hint ? <span className="text-text-tertiary"> ({hint})</span> : null}
      </span>
    </div>
  );
};

export default DataFreshnessBanner;
